module.exports = __webpack_public_path__ + "images/videoCaseStudy-challenge-sideBg.svg?h=9ce4835d31c3195da178a8e4a73b343d";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg
// module id = 1477
// module chunks = 12 15